export function createAuthSession({ http, storage, authUrl, onUnauthorized, onTokenRenewed }) {
  let pending = null;
  const credentials = () => ({ key: storage.getItem('key'), token: storage.getItem('x_auth') });
  const isCurrent = session => session.key === storage.getItem('key');

  function authenticate(key = storage.getItem('key')) {
    const session = credentials();
    if (pending && pending.key === key && pending.sessionKey === session.key) return pending.promise;

    const operation = { key, sessionKey: session.key };
    operation.promise = http.post(authUrl(), { token: key }).then(async response => {
      if (response.data.success && response.data.x_auth && isCurrent(session)) {
        storage.setItem('key', key);
        storage.setItem('x_auth', response.data.x_auth);
        await onTokenRenewed(response.data.x_auth);
      }
      return response;
    }, error => {
      if (error.status === 401 && isCurrent(session)) onUnauthorized();
      throw error;
    }).finally(() => {
      if (pending === operation) pending = null;
    });
    pending = operation;
    return operation.promise;
  }

  async function renew(session) {
    if (!isCurrent(session)) return false;
    if (session.token === storage.getItem('x_auth')) {
      const response = await authenticate(session.key);
      if (!response.data.success || !response.data.x_auth) throw response;
    }
    return isCurrent(session) && !!storage.getItem('x_auth');
  }

  return { credentials, authenticate, renew };
}
